// apps/api/src/qxcircle/qxcircle-like-action.ts
// Description: QXCircle like toggle + local like notification (Slice 17).
// Owner: Masa Bayu
// Date: 2026-08-24

import { createLikeNotification } from "./qxcircle-like-notification";
import { isManagedQxCirclePost } from "./qxcircle-post-presenter";
import type { QxCircleFeedPost, QxCircleNotification } from "./qxcircle.types";

export function toggleQxCircleLike(
  post: QxCircleFeedPost,
  localLikes: Set<string>,
  ntfSeq: number,
): {
  notification: QxCircleNotification | null;
  nextSeq: number;
} {
  if (localLikes.has(post.id)) {
    localLikes.delete(post.id);
    post.likeCount = Math.max(0, post.likeCount - 1);
    return { notification: null, nextSeq: ntfSeq };
  }
  localLikes.add(post.id);
  post.likeCount += 1;
  if (isManagedQxCirclePost(post)) {
    return { notification: null, nextSeq: ntfSeq };
  }
  const nextSeq = ntfSeq + 1;
  return {
    nextSeq,
    notification: createLikeNotification(nextSeq, post.authorName, post.id),
  };
}
